import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

export default function BkContractSelector(items) {
  const [shopScope] = useState(items.shopScope || 'dsl-bk')
  const [contracts, setContracts] = useState(items.contracts || null)
  const activeContractNumber = contracts?.activeContractNumber
  const selectedItem =
    contracts?.mobileContracts
      .concat(contracts?.dslContracts)
      .filter(item => item.contractNumber == activeContractNumber)[0] || {}

  const activeScope =
    contracts?.dslContracts.filter(item => item.contractNumber == activeContractNumber).length == 1 ? 'dsl' : 'mobile'
  const mobileLinkTargetPage = activeScope == 'mobile' ? '/tariffupgrade' : '/mobile-tariffupgrade'
  const dslLinkTargetPage = activeScope == 'dsl' ? '/tarifftable' : '/dsl-tarifftable'

  const getUserContracts = async function () {
    let headers = new Headers()
    headers.append('x-cdp-shop-scope', shopScope)

    // const  cartFacadeEndpoint = "https://proxy-mobile-delivery-layer-docdp-11020-contract-se.qa.tesa.server.lan/frontend/cart-facade/contract-selection"
    const cartFacadeEndpoint = '/frontend/cart-facade/contract-selection'

    fetch(cartFacadeEndpoint, {
      headers: headers
    })
      .then(response => {
        const contentType = response.headers.get('content-type')
        if (!contentType || !contentType.includes('application/json')) {
          throw new TypeError("Oops, we haven't got JSON!")
        }
        return response.json()
      })
      .then(data => {
        setContracts(data)
        // reinitialize XLAB JS
        if (typeof window.initializedClasses?.SubNavigationBkInitializer == 'object') {
          new window.initializedClasses.SubNavigationBkInitializer.constructor()
        }
      })
      .catch(error => console.error(error))
  }

  useEffect(() => {
    if (!contracts) {
      getUserContracts()
    }
    // reinitialize XLAB JS
    if (typeof window.initializedClasses?.SubNavigationBkInitializer == 'object') {
      new window.initializedClasses.SubNavigationBkInitializer.constructor()
    }
  })

  const clickHandler = () => {
    ReactDOM.render(
      <div className="overlay animated overlay__secondary fade-in">
        <div
          className="loader loader--dark"
          style={{ position: 'absolute', top: 'calc(50vh - 30px)', left: 'calc(50vw - 30px)' }}
        >
          {[...Array(12)].map(key => (
            <div key={key} className="loader__child"></div>
          ))}
        </div>
      </div>,
      document.body
    )
  }

  return (
    <>
      <div className="subnavigation-bk__select-flyout-button">
        <div className="subnavigation-bk__contract">{selectedItem?.offerTitle}</div>
        <div className="subnavigation-bk__divider">|</div>
        <div className="subnavigation-bk__contract-number">{selectedItem?.contractNumber}</div>
        <svg viewBox="0 0 100 100" className="icon icon--medium">
          <use href="#arrow--down"></use>
        </svg>
      </div>

      <div className="subnavigation-bk__groups" style={{ display: 'none' }}>
        <div className="arrow-up" style={{ left: '156.131px' }}></div>

        {contracts?.dslContracts.length > 0 && (
          <ul className="subnavigation-bk__group-container">
            <li className="subnavigation-bk__group_title">DSL &amp; Telefonie</li>
            {contracts?.dslContracts.map(item => (
              <ul
                key={item.contractNumber}
                className="subnavigation-bk__group-item"
                role="option"
                data-value=""
                title={item.offerTitle + ' | ' + item.contractNumber}
                tabIndex="-1"
              >
                <a href={dslLinkTargetPage + '?hashContractId=' + item.hashContractId} onClick={clickHandler}>
                  <div className="subnavigation-bk__tariff-name">{item.offerTitle}</div>
                  <div className="subnavigation-bk__tariff-desc">
                    {item.userAlias ? item.userAlias : 'DSL & TELEFONIE'}
                  </div>
                  <div className="subnavigation-bk__tariff-number">Vertragsnummer: {item.contractNumber}</div>
                </a>
              </ul>
            ))}
          </ul>
        )}

        {contracts?.mobileContracts.length > 0 && (
          <ul className="subnavigation-bk__group-container">
            <li className="subnavigation-bk__group_title">Mobilfunk</li>
            {contracts?.mobileContracts.map(item => (
              <ul
                key={item.contractnumber}
                className="subnavigation-bk__group-item"
                role="option"
                data-value=""
                title={item.offerTitle + ' | ' + item.contractNumber}
                tabIndex="-1"
              >
                <a href={mobileLinkTargetPage + '?hashContractId=' + item.hashContractId} onClick={clickHandler}>
                  <div className="subnavigation-bk__tariff-name">{item.offerTitle}</div>
                  <div className="subnavigation-bk__tariff-desc">{item.userAlias ? item.userAlias : 'MOBILFUNK'}</div>
                  <div className="subnavigation-bk__tariff-number">Rufnummer: {item.phoneNumber}</div>
                </a>
              </ul>
            ))}
          </ul>
        )}
      </div>
    </>
  )
}
